@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.icon-message-column {
  display: flex;
  height: 30px;

  &.empty,
  &.error {
    .default-icon {
      > svg {
        color: @columns--icon-message-default--error--text-color;
      }
    }
  }

  &.error {
    .message {
      color: @columns--icon-message--error--text-color;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.default-icon,
.error-icon {
  height: 30px;
  width: 20px;
  min-width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  > svg {
    height: 18px;
    width: 18px;
  }
}

.default-icon {
  > svg {
    color: @columns--icon-message-default--text-color;
  }
}

.error-icon {
  padding-left: 5px;

  > svg {
    color: @columns--icon-message--error--text-color;
  }
}

.message {
  .truncate();
  width: 100%;
  color: @columns--icon-message--text-color;
  font-size: 13px;
  line-height: 30px;
  padding-left: 5px;
}

.error-container {
  display: flex;
}

.date {
  padding-left: 5px;
}
